import { IconProps } from '@chakra-ui/react';
import { Icon } from '@diamond/shared/ui';

export const CheckboxOutlineBlankIcon = (props: IconProps) => {
  return (
    <Icon
      as="svg"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_12389_52761"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_12389_52761)">
        <path
          d="M5.75 11.75H12.4375C12.6875 11.75 12.875 11.6719 13 11.5156C13.125 11.3594 13.1875 11.1875 13.1875 11C13.1875 10.8125 13.125 10.6406 13 10.4844C12.875 10.3281 12.6875 10.25 12.4375 10.25H5.75C5.5375 10.25 5.35938 10.3215 5.21563 10.4644C5.07188 10.6073 5 10.7844 5 10.9956C5 11.2069 5.07188 11.3854 5.21563 11.5312C5.35938 11.6771 5.5375 11.75 5.75 11.75ZM5.75 8.75H9.25C9.4625 8.75 9.64062 8.67854 9.78438 8.53563C9.92813 8.39271 10 8.21563 10 8.00438C10 7.79313 9.92813 7.61458 9.78438 7.46875C9.64062 7.32292 9.4625 7.25 9.25 7.25H5.75C5.5375 7.25 5.35938 7.32146 5.21563 7.46437C5.07188 7.60729 5 7.78437 5 7.99562C5 8.20687 5.07188 8.38542 5.21563 8.53125C5.35938 8.67708 5.5375 8.75 5.75 8.75ZM3.5 15C3.0875 15 2.73438 14.8531 2.44063 14.5594C2.14688 14.2656 2 13.9125 2 13.5V5.5C2 5.0875 2.14688 4.73438 2.44063 4.44063C2.73438 4.14688 3.0875 4 3.5 4H16.5C16.9125 4 17.2656 4.14688 17.5594 4.44063C17.8531 4.73438 18 5.0875 18 5.5V7.25C18 7.4625 17.9285 7.64063 17.7856 7.78438C17.6427 7.92813 17.4656 8 17.2544 8C17.0431 8 16.8646 7.92813 16.7188 7.78438C16.5729 7.64063 16.5 7.4625 16.5 7.25V5.5H3.5V13.5H9.25C9.4625 13.5 9.64062 13.5715 9.78438 13.7144C9.92813 13.8573 10 14.0344 10 14.2456C10 14.4569 9.92813 14.6354 9.78438 14.7812C9.64062 14.9271 9.4625 15 9.25 15H3.5ZM18.4077 10.4756C18.4692 10.5376 18.5 10.6058 18.5 10.6802C18.5 10.7545 18.4653 10.8264 18.3958 10.8958L17.75 11.5625L16.4375 10.25L17.0833 9.58333C17.1496 9.51389 17.2225 9.47917 17.3021 9.47917C17.3817 9.47917 17.4546 9.51389 17.5208 9.58333L18.4077 10.4756ZM17.3125 12L12.5417 16.7708C12.4722 16.8403 12.3924 16.8958 12.3021 16.9375C12.2118 16.9792 12.1145 17 12.0102 17H11.3648C11.2605 17 11.1736 16.9653 11.1042 16.8958C11.0347 16.8264 11 16.7395 11 16.6352V15.9898C11 15.8855 11.0208 15.7882 11.0625 15.6979C11.1042 15.6076 11.1597 15.5278 11.2292 15.4583L16 10.6875L17.3125 12Z"
          fill="currentColor"
        />
      </g>
    </Icon>
  );
};
